<template>
  <div>
    <div class="plantht">
      <div class="planttxt" style="min-height: 500px">
        <h5 class="planth5">产品中心</h5>
        <div class="imgcontainer">

          <div class="container">
            <div class="left_part">
              <ul>
                <li
                  v-for="(item, index) in leftList"
                  :key="index"
                  @click="select(item.idx)"
                  :class="selectIndex == item.idx ? 'active' : ''"
                >
                  <a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="right_part" ref="box">
              <div v-if="showlist[6]">
                <p class="title" id="id1">开源因子库</p>
                <p><common-data name="appShortName_37"/>提供量价类-技术指标、量价类-波动率因子、财务类、公司资料类等十几个大类133个开源系统因子。 </p>
                 <!-- <Imggs :src="require('../../assets/img/kyyzk1.png')" alt="" @click.native="showimg(require('../../assets/img/kyyzk1.png'))" width="80%"/> -->
                <p>系统因子Python源代码的开放，可以帮助理解因子编写逻辑，也为自编因子提供完善的基础代码框架和编写示例。</p>
                <p>软件的策略案例，也是完全采用开源因子库里的因子来构建的，实现了还不错的收益率表现。 </p>
                 <Imggs :src="require('../../assets/img/kyyzk2.png')" alt="" @click.native="showimg(require('../../assets/img/kyyzk2.png'))" width="80%"/>
                <p>开源因子列表：</p>
                <table class="buytable" style="margin-top:1px">
                  <tr>
                    <td width="90px" style="text-align:center;">因子类别</td>
                    <td width="170px" style="text-align:center">分类</td>
                    <td style="text-align:center">说明</td>
                    <td width="88px" style="background:#c75438;color:white;text-align:center">数量</td>
                  </tr>
                  <tr>
                      <td rowspan="13" style="text-align:center">股票因子</td>
                      <td>量价类-技术指标</td>
                      <td rowspan="6">技术、波动率、换手率、成交量等量价类因子；</td>
                      <td>25</td>
                  </tr>
                  <tr>
                      <td>量价类-波动率因子</td>
                      <td >4</td>
                  </tr>
                  <tr>
                      <td>量价类-换手率因子</td>
                      <td>2</td>
                  </tr>
                  <tr>
                      <td>量价类-成交量因子</td>
                      <td>4</td>
                  </tr>
                  <tr>
                      <td>量价类-资金流向因子</td>
                      <td>4</td>
                  </tr>
                  <tr>
                      <td>量价类-横向比较</td>
                      <td>1</td>
                  </tr>
                  <tr>
                      <td>财务类-盈利能力</td>
                      <td rowspan="6">盈利、成长、市场估值、持股结构等财务类因子；</td>
                      <td>10</td>
                  </tr>
                  <tr>
                      <td>财务类-财务质量</td>
                      <td>11</td>
                  </tr>
                  <tr>
                      <td>财务类-成长性</td>
                      <td>5</td>
                  </tr>
                  <tr>
                      <td>财务类-盈利预测</td>
                      <td>4</td>
                  </tr>
                  <tr>
                      <td>财务类-市场估值</td>
                      <td>9</td>
                  </tr>
                  <tr>
                      <td>公司资料类-持股结构</td>
                      <td>3</td>
                  </tr>
                   <tr>
                      <td>另类因子</td>
                      <td>估值线买点、强弱度等特色因子；</td>
                      <td>9</td>
                  </tr>
                
                  <tr>
                      <td rowspan="4" style="text-align:center">可转债因子</td>
                      <td>市场估值类</td>
                      <td rowspan="4">可转债估值、量价、正股特征等常用因子和BS定价期权价值/溢价率等特色因子；</td>
                      <td>23</td>
                  </tr>
                  <tr>
                      <td>量价类</td>
                      <td>8</td>
                  </tr>
                  <tr>
                      <td>正股财报类</td>
                      <td>9</td>
                  </tr>
                  <tr>
                      <td>正股量价类</td>
                      <td>6</td>
                  </tr>
                  <tr class="kongbai">
                    <td td colspan="3" style="text-align:right;padding-right:10px">因子总计</td>
                    <td style="color: rgb(202, 67, 67);font-weight: bold;font-size: 18px;text-align:center;padding-right:0">133</td>
                  </tr>
                </table>
              </div>
              <div v-if="showlist[0]">
                <p class="title" id="id1">另类数据</p>
                <p>传统的量价类因子、财务类因子可能无法全面捕捉市场的动态和复杂性，稀缺独特的另类因子是投资者获取超额收益、不断提升业绩的致胜性因素。</p>
                <p>
                  目前，<common-data name="appShortName_37"/>提供以下另类数据，未来还将逐渐更新并提供更多的特色另类数据。
                </p>
                <p>
                  1、多因子估值数据：
                </p>
                <p >
                  通过股票多因子估值数据可以获得更精准的股票估值水平信息。一方面可以通过低估值水平分析和构建中长期价值投资策略；另一方面也可以通过高估值水平精选市场关注度高、交易惯性强的股票，结合技术分析捕捉趋势机会，获取更高收益。
                </p>
                <p>
                  该数据可通过get_balanced_price函数调用。
                </p>
                <Imggs :src="require('../../assets/img/llsj1.jpg')" alt="" @click.native="showimg(require('../../assets/img/llsj1.jpg'))" width="80%"/>
                <p>
                  2、日内统计数据：
                </p>
                <p >
                  通过tick、1分钟、15分钟、30分钟等高频分钟线数据挖掘得到的在日内具有高信息增益的数据，可以及时准确的捕捉市场动向、挖掘待涨股票，帮助用户制定更准确的选股策略。
                </p>
                <p>
                  该数据可通过get_intraday_statistics函数调用。 
                </p>
                <Imggs :src="require('../../assets/img/llsj3.jpg')" alt="" @click.native="showimg(require('../../assets/img/llsj3.jpg'))" width="80%"/>          
              </div>
              <div v-if="showlist[1]">
                <p class="title" id="id2">可视化策略构建平台 </p>
                <p>开创性的多因子策略构建平台，在因子数据处理、调仓机制做了创新性改进，还支持引入独有的多因子估值数据来优化买卖点，来优化策略，提高收益率、回撤比等指标的表现。</p>
                <p>1、对因子数据智能化处理</p>
                <p>
                  系统实现了对因子数据的去极值、缺失值、标准化、中性化、正交化、方向判断等的智能化处理，所有因子可直接使用，提高了策略研发效率。
                </p>
                <Imggs :src="require('../../assets/img/tsgn1.jpg')" alt="" @click.native="showimg(require('../../assets/img/tsgn1.jpg'))" width="80%"/>
                <p>2、创新性的调仓机制</p>
                <p>
                 系统设计了更加符合交易逻辑的调仓规则，每次轮动交易时调仓的股票数量改为可控参数，降低了调仓成本，可操作性更强，更加贴合实际交易习惯。
                </p>
                <Imggs :src="require('../../assets/img/tsgn2.jpg')" alt="" @click.native="showimg(require('../../assets/img/tsgn2.jpg'))" width="80%"/>
                <p>3、启动止损优化收益</p>
                <p>创新性的在调仓过程中加入了估值数据判断，有效防止调仓时买入市场热度处于峰值的股票，且能够在股票热度衰减初期，下跌趋势出现之前及时止盈，显著提高策略收益。</p>
                <Imggs :src="require('../../assets/img/tsgn7.jpg')" alt="" @click.native="showimg(require('../../assets/img/tsgn7.jpg'))" width="80%"/>
                <p>4、多维度的回测报告</p>
                <p>系统提供了多维度的回测报告，涵盖收益分析、回测分析、收益归因、行业分布、交易分析、历史持仓列表、最新持仓列表、因子贡献度分析等多维度的数据和图表信息，可直观了解策略收益风险水平和交易情况。其中收益归因还支持了Brinson行业归因和Barra风格归因。</p>
                <Imggs :src="require('../../assets/img/tsgn4.jpg')" alt="" @click.native="showimg(require('../../assets/img/tsgn4.jpg'))" width="80%"/>
                <p>Brinson行业归因：展示回测区间策略的超额收益分解情况，把握策略超额收益主要来源于行业内选股收益还是行业本身的配置收益。</p>
                <Imggs :src="require('../../assets/img/tsgn5.png')" alt="" @click.native="showimg(require('../../assets/img/tsgn5.png'))" width="80%"/>
                <p>Barra风格归因：将策略的绝对收益/超额收益，分解到十类典型的风格因子上，如价值风格、成长风格等，进而分析风格暴露情况对策略收益的影响。</p>
                <Imggs :src="require('../../assets/img/tsgn6.png')" alt="" @click.native="showimg(require('../../assets/img/tsgn6.png'))" width="80%"/>
                <p class="zhushi">
                  注：系统还支持市场中性化策略的构建，提供市值对冲、期货Beta对冲，系统性风险对冲三种对冲策略。
                </p>
              </div>
              <div v-if="showlist[5]">
                <p class="title" id="id4">策略案例</p>
                <p><common-data name="appShortName_37"/>基于多因子估值数据库，提供开源的股票多因子策略案例，策略年化收益率超过20%，同时持仓100支股票，理论上能够管理10亿资金规模。</p>
                <p>投资者可以参考系统策略的构建方法，建立自己的多因子策略，避开同质化策略可能造成的“交易堵车”。</p>
                <Imggs :src="require('../../assets/img/clal1.jpg')" alt="" @click.native="showimg(require('../../assets/img/clal1.jpg'))" width="80%"/>
                <p>软件也提供市场中性以及可转债策略等多种策略案例。</p>
                <p>未来，<common-data name="appShortName_37"/>也将与时俱进，及时更新进行更多案例的上传和更新。</p>
                <p>具体策略细节描述，详见【<common-data name="appShortName_37"/>-策略-研究文案】。</p>
                <Imggs :src="require('../../assets/img/clal2.jpg')" alt="" @click.native="showimg(require('../../assets/img/clal2.jpg'))" width="80%"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Baseimg :src='src' :show='ifimg' @change="ifimg=false"/>
  </div>
</template>

<script>
import Baseimg from '../view/frame/Baseimg.vue'
import Imggs from '../view/frame/Imggs.vue'
export default {
  components:{Baseimg,Imggs},
  data() {
    return {
      leftList: [
        // { name: "文华因子库" ,idx:0},
        { name: "开源因子库" ,idx:6},
        { name: "可视化策略构建平台 " ,idx:1},
        { name: "另类数据" ,idx:0},
        // { name: "行业轮动策略量化",idx:2 },
        // { name: "商品CTA策略" ,idx:3},
        // { name: "可转债策略量化" ,idx:7},
        // { name: "选择因子参考资料",idx:4 },
        { name: "策略案例" ,idx:5},
      ],
      showlist: [true, false, false, false, false,false, false, false],
      selectIndex: 0,
      src:'',
      ifimg:false,
    };
  },
  methods: {
    select(index) {
      console.log(index)
      this.setid(index)
      this.showlist.forEach((el, idx) => {
        this.showlist[idx] = false;
      });
      this.showlist[index] = true;
      this.selectIndex = index;
      // this.custormAnchor(`id${index + 1}`);
    },
    setid(id){
      this.$router.push('/plantform/'+id)
    },
    showimg(e){
      console.log(e)
      this.src=e
      this.ifimg=true
    },
    // custormAnchor(anchorName) {
    //   var target = document.getElementById(anchorName);
    //   if (target !== null) {
    //     this.$refs.box.scrollTop = target.offsetTop;
    //   }
    // },
  },
  mounted() {
    this.select(this.$route.params.id);
  },
};
</script>

<style scoped>
.packkua {
  width: 900px;
  margin: 0 auto;
  min-height: 0px;
  margin-top: 50px;
}
.packh4 {
  background: #f5e5e5;
  height: 25px;
}
.h4img {
  float: left;
  margin-top: -12px;
}
.imgcontainer {
  /* padding: 0 10px; */
  /* background: #f5f5f5; */
  border-left: 1px solid #f5f5f5 
}
.h4ti {
  width: 95px;
  border-radius: 0 0 30px 0;
  background: #e04a49;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt {
  padding: 20px 0 40px 0;
  width: 100%;
}
.kuatxt p {
  line-height: 25px;
  padding: 10px 0;
  font-size: 14px;
  text-indent: 2em;
  color: #6f6f6f;
  text-align: justify;
}
.plantht {
  min-height: 600px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=53) no-repeat top;
  overflow: hidden;
}
.planttxt {
  width: 990px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 236px;
  padding: 30px 30px 0 30px;
  background: white;

  box-shadow: 0 0 20px -5px #ccc;
}
.planth5 {
  font-size: 22px;
  color: #5f5f5f;
  border-bottom: 1px dashed #7f7f7f;

  line-height: 40px;
}
.planth4 {
  background: #ffe9dc;
  height: 25px;
  width: 920px;
}
.h4ti1 {
  width: 111px;
  border-radius: 0 0 30px 0;
  background: #e0a180;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt p {
  width: 600px;
  line-height: 25px;
  text-align: justify;
}
.kuatxt {
  width: 600px;
  display: inline-block;
}
.imgs {
  display: inline-block;
  margin-left: 30px;
}
.imgtop div {
  color: #292929;
  text-indent: 2em;
  font-size: 15px;
  padding: 5px 0;
}
.container {
  width: 100%;
  position: relative;
  background: white;
  margin-top: 20px;
}
.right_part::-webkit-scrollbar {
  width: 0;
}
.left_part {
  display: inline-block;
  width: 259px;
  height: 100%;
  border-top: 1px solid #f5f5f5;
}
.left_part .title {
  width: calc(100% - 20px);
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  /* font-weight: bold; */
  background: url(../../assets/img/ts2.jpg) no-repeat center;
  background-size: 100% 100%;
  vertical-align: top;
  color: #fff;
  padding-left: 20px;
}
.left_part ul li {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-size: 15px;
  color: #827373;
  border-bottom: 1px solid #ececec;
}
.left_part ul li:hover {
  color: #b56f6f;
}
.left_part ul li.active {
  background: #e57373;
  /* box-shadow: 2px 4px 4px #bebcbc inset; */
  color: white;
}
.left_part ul li a {
  width: 85%;
  margin: 0 auto;
  display: block;
  text-indent: 1em;
  position: relative;
}
.right_part {
  display: inline-block;
  width: 648px;
  height: 100%;
  vertical-align: top;
  background: #f5f5f5;
  padding: 20px 40px;
  color: #8a8a8a;
  /* box-shadow: -4px 4px 4px #bebcbc inset; */
  background: #efefef;
}
.right_part p {
  text-indent: 2em;
  padding: 5px 0;
  font-size: 14px;
  text-align: justify;
  line-height: 24px;
}
.right_part img {
  margin: 20px auto;
  display: block;
}
.right_part .title {
  font-size: 16px;
  font-weight: bold;
  text-indent: 0;
  color: #7e4040;
}



.buytable {
  margin-top: 15px;
  width: 580px;
  margin:  0 auto;
  margin-bottom: 20px;
}

.buytable tr {
  /* height: 35px; */
  vertical-align: middle;
  color: #4c4c4c;
  font-size: 14px;
}
.buytable tr:first-child > td {
  padding: 6px 0 !important;
  line-height: 24px;
}
.buytable td {
  padding-left: 50px;
  vertical-align: middle;
  line-height: 20px;
  color: #4d4d4d;
}
.buytable tr td:first-child {
  padding-left: 0px;
  text-align: center;
}
.buytable2 td{
  line-height: 20px;
  padding: 8px 0;
  text-align: center !important;
  padding-right: 0 !important;
}

.lightTr {
  background: #f7f7f7;
}
.buytable tr:first-child {
  /* height: 40px;
  line-height: 40px; */
  background: #c75438;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}
.buytable tr:first-child td {
  padding-left: 0;
  color: inherit;
}
.buytable tr td:nth-last-child(4) {
  /* background: #fef7fa; */
  text-align: justify;
  padding:2px 10px;
}
.buytable tr td:nth-last-child(3) {
  /* background: #fef7fa; */
  text-align: justify;
  padding:4px 8px;
}
.buytable tr td:nth-last-child(2) {
  /* background: #fffff9; */
  text-align: justify;
  padding: 4px 8px;
}
/* .buytable tr td:nth-last-child(2) {
  text-align: center;
  padding-left: 0;
} */
.buytable tr td:nth-last-child(1) {
  /* background: #fffff9; */
  text-align: center;
  padding-left: 0;
}
.firstline td:first-child {
  text-align: center;
  padding: 0 !important;
}
/*.firstline td:nth-child(2){
  background: none  !important;
}
.firstline td:nth-child(3){
  background: #fef7fa !important;
}
.firstline td:nth-child(4){
  background: #fffff9;
} */
.col td {
  background: white !important;
  text-align: left !important;
  padding-left: 50px !important;
}
.col td:last-child {
  padding-left: 90px !important;
}
.buytable td {
  border: 1px solid #e6e4e4;
  border-bottom: 1px solid #bcbaba;
  background: white;
}
.buytable tr:first-child td{
  background: #c75438;
}
</style>